












import Component from 'vue-class-component';
import Vue from 'vue';
import Modal from '@/components/Modal.vue';
import { Prop } from 'vue-property-decorator';
import { Notification } from '@/core/interfaces/notification';
import NotificationCard from '@/components/notification/NotificationCard.vue';

@Component({
    components: { NotificationCard, Modal },
})
export default class NotificationModal extends Vue {
    @Prop({ required: true })
    notification!: Notification;
}
